import { render } from "./Apparel.vue?vue&type=template&id=73a73a44&scoped=true"
import script from "./Apparel.vue?vue&type=script&lang=js"
export * from "./Apparel.vue?vue&type=script&lang=js"

import "./Apparel.vue?vue&type=style&index=0&id=73a73a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a73a44"]])

export default __exports__